/**
 * Title Finder Property Searches Mobile Hotfix — Google Places single-tap fix for iOS/Android
 *
 * Root cause this guards against:
 * - Google Places renders suggestions in a .pac-container outside the product form.
 * - On mobile Safari/Chrome, tapping a .pac-item can blur the input without firing
 *   the Autocomplete place_changed callback, so the visible suggestion is tapped but
 *   #product-address-input remains unchanged.
 *
 * This keeps the Google selection behaviour, then falls back to writing the tapped
 * suggestion text into the active Title Finder Property Searches address input so Buy Now always has
 * a property address to submit.
 */
(function() {
  var NSW_UNAVAILABLE_MESSAGE = 'Sorry, we no longer sell NSW title searches. Please choose a non-NSW property.';

  function isNSWPostcode(postcode) {
    var code = parseInt(postcode, 10);
    return (code >= 1000 && code <= 1999) ||
      (code >= 2000 && code <= 2599) ||
      (code >= 2619 && code <= 2899) ||
      (code >= 2921 && code <= 2999);
  }

  function isNSWAddress(address, stateCode) {
    if (stateCode === 'NSW') return true;
    var text = String(address || '').toUpperCase();
    if (/\bNSW\b/.test(text) || /\bNEW SOUTH WALES\b/.test(text)) return true;
    var postcodeMatch = text.match(/\b(\d{4})\b(?:\s*,?\s*AUSTRALIA)?$/);
    return postcodeMatch ? isNSWPostcode(postcodeMatch[1]) : false;
  }

  function placeStateCode(place) {
    var stateCode = null;
    (place && place.address_components || []).forEach(function(component) {
      if (component.types.indexOf('administrative_area_level_1') !== -1) {
        stateCode = component.short_name;
      }
    });
    return stateCode;
  }

  function showNSWUnavailable(input) {
    try {
      localStorage.removeItem('tf_address');
      localStorage.removeItem('selectedAddress');
      localStorage.removeItem('tf_state');
    } catch (e) {}
    if (input) {
      input.value = '';
      input.classList.remove('valid-address');
      input.style.borderColor = '#ef4444';
      input.style.backgroundColor = '#fef2f2';
      input.focus();
    }
    var helpEl = document.getElementById('buy-now-help');
    if (helpEl) {
      helpEl.textContent = NSW_UNAVAILABLE_MESSAGE;
      helpEl.style.display = 'block';
    } else {
      alert(NSW_UNAVAILABLE_MESSAGE);
    }
  }

  window.__tfMobileNSWGuard = {
    isNSWAddress: isNSWAddress
  };

  var isTouchDevice = ('ontouchstart' in window || navigator.maxTouchPoints > 0);
  if (!isTouchDevice) return;

  var touchingPacItem = false;
  var lastPacItem = null;
  var lastPacText = '';

  function getAddressInputs() {
    return [
      document.getElementById('product-address-input'),
      document.getElementById('address-input')
    ].filter(Boolean);
  }

  function getActiveAddressInput() {
    var active = document.activeElement;
    if (active && (active.id === 'product-address-input' || active.id === 'address-input')) {
      return active;
    }
    var inputs = getAddressInputs();
    return inputs[0] || null;
  }

  function pacItemText(item) {
    if (!item) return '';
    var query = '.pac-item-query';
    var main = item.querySelector(query) ? item.querySelector(query).textContent.trim() : '';
    var full = item.textContent.replace(/\s+/g, ' ').trim();
    if (main && full.indexOf(main) === 0) {
      var secondary = full.slice(main.length).trim();
      return (main + (secondary ? ', ' + secondary : '')).replace(/,\s*,/g, ',').trim();
    }
    return full;
  }

  function markAddressSelected(input, address) {
    if (!input || !address) return;
    if (isNSWAddress(address)) {
      showNSWUnavailable(input);
      return;
    }
    input.value = address;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.style.borderColor = '#10b981';
    input.style.backgroundColor = '#f0fdf4';
    try {
      localStorage.setItem('tf_address', address);
      localStorage.setItem('selectedAddress', address);
    } catch (e) {}
  }

  function fallbackPopulateFromPacItem(item) {
    var input = getActiveAddressInput();
    if (!input) return;

    // Give Google Autocomplete a moment to populate formatted_address first.
    var before = input.value;
    setTimeout(function() {
      if (!input.value || input.value === before) {
        var text = pacItemText(item) || lastPacText;
        if (text) markAddressSelected(input, text);
      }
    }, 180);
  }

  // Capture the item being tapped. Do not preventDefault here; preventing touchstart
  // is one of the things that can stop Google's own handlers from completing.
  document.addEventListener('touchstart', function(e) {
    var item = e.target.closest && e.target.closest('.pac-item');
    if (item) {
      touchingPacItem = true;
      lastPacItem = item;
      lastPacText = pacItemText(item);
    }
  }, { passive: true, capture: true });

  // Simulate the mouse/pointer sequence Google Places expects, then fall back to
  // populating the input ourselves if Google did not fire place_changed.
  document.addEventListener('touchend', function(e) {
    if (!touchingPacItem) return;
    var item = (e.target.closest && e.target.closest('.pac-item')) || lastPacItem;
    touchingPacItem = false;
    if (!item) return;

    e.preventDefault();
    e.stopPropagation();

    ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function(type, index) {
      setTimeout(function() {
        var Ctor = type.indexOf('pointer') === 0 && window.PointerEvent ? PointerEvent : MouseEvent;
        item.dispatchEvent(new Ctor(type, { bubbles: true, cancelable: true, view: window, pointerType: 'touch' }));
      }, index * 20);
    });

    fallbackPopulateFromPacItem(item);
  }, { passive: false, capture: true });

  // Also ensure Google Autocomplete exists on the product address field if the
  // product script missed the Maps load timing. NSW is blocked because we no
  // longer sell NSW title products.
  function ensureAutocomplete() {
    if (!window.google || !window.google.maps || !window.google.maps.places) return;

    getAddressInputs().forEach(function(input) {
      if (input.__mobileFixApplied) return;

      if (input.id === 'address-input' && !input.__tfAutocomplete && typeof window.initTFAddressAutocomplete === 'function') {
        window.initTFAddressAutocomplete();
      }

      if (!input.__tfProductAC && !input.__tfAutocomplete && !input.__mobileFixAC) {
        try {
          var ac = new google.maps.places.Autocomplete(input, {
            types: ['address'],
            componentRestrictions: { country: 'AU' },
            fields: ['formatted_address', 'address_components']
          });
          ac.addListener('place_changed', function() {
            var place = ac.getPlace();
            if (!place || !place.formatted_address) return;
            if (isNSWAddress(place.formatted_address, placeStateCode(place))) {
              showNSWUnavailable(input);
              return;
            }
            markAddressSelected(input, place.formatted_address);
            setTimeout(function() { input.blur(); }, 100);
          });
          input.__mobileFixAC = ac;
        } catch(e) {}
      }

      input.__mobileFixApplied = true;
    });
  }

  var attempts = 0;
  var poller = setInterval(function() {
    ensureAutocomplete();
    var productReady = document.getElementById('product-address-input') && document.getElementById('product-address-input').__mobileFixApplied;
    var legacyReady = document.getElementById('address-input') && document.getElementById('address-input').__mobileFixApplied;
    if (productReady || legacyReady || ++attempts > 100) clearInterval(poller);
  }, 100);

  document.addEventListener('DOMContentLoaded', ensureAutocomplete);
  window.addEventListener('load', ensureAutocomplete);

  var style = document.createElement('style');
  style.textContent = '.pac-container{z-index:100001!important}.pac-item{padding:14px 10px!important;min-height:48px!important;font-size:16px!important;line-height:1.4!important;cursor:pointer!important;touch-action:manipulation!important}.pac-item:active{background:#e8f4f8!important}';
  document.head.appendChild(style);
})();
